import { Alert, Button, Checkbox, Col, message, Row, Space, Spin, Tag, Typography } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import DetailItem from "../../../components/DetailItem";
import ListingImagePreview from "../../../components/ListingImagePreview";
import SellOrRentComponent from "../../../components/SellOrRentComponent";
import { formatDate, formatUcWords } from "../../../helpers/format";
import { getListingPrice, getListingPriceNominal, priceFormat } from "../../../helpers/priceFormat";
import { EListingSellOrRent, EListingStatus, EPortalListingResultStatus } from "../../../types/listing.type";
import { EProfileMainEmail } from "../../../types/profile.type";
import MapsPickerComponent from "../CreateComponents/MapsPickerComponent";
import { StepProps } from "../Detail";
import { EmailPortal } from "../../../types/employee.type";
import { PortalListingProperties, PortalListingSyncProperties } from "../../../types/portalListing.type";
import InfoPortalSync from "./InfoPortalSync";
import { httpRequest } from "../../../helpers/api";
import AgentPortal from "./AgentPortal";
import { getErrorMessage, showErrorMessage } from "../../../helpers/errorHandler";
import NotSet from "../../../components/NotSet";
import { ExclamationCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { BaseResponseProps, BaseResponsePaginationProps } from "../../../types/config.type";
import PortalSyncLogModal from "../components/PortalSyncLogModal";
import { PortalProperties } from "../../../types/portal.type";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import useAuth from "../../../hooks/useAuth";
import { maskEmail } from "../../../helpers/text";
import { LAMUDI_ID } from "../../employee/constant";

const { Title } = Typography;
export interface EmailListing extends PortalListingProperties {
	emailPortalListing: EmailPortal;
}
interface Props extends StepProps {
	isMinimal?: boolean;
	hideNavigation?: boolean;
	isHideListingCode?: boolean;
	hasListingPortal?: boolean;
	isClosing?: boolean;
	isHideListingPortal?: boolean;
}
const DetailListingInformation: React.FC<Props> = ({
	listing,
	listingId,
	isMinimal,
	hideNavigation,
	isHideListingCode,
	listingPortals,
	hasListingPortal,
	isClosing,
	isHideListingPortal,
	setIsFetch,
}) => {
	const history = useHistory();
	const { isAdminOfficePlus } = useAuth();
	// const [emailConnectedToR123, setEmailConnectedToR123] = useState(false);
	// const [isCheckingR123Email, setIsCheckingR123Email] = useState(false);
	const [showLog, setShowLog] = useState(false);
	const [selectedPortalId, setSelectedPortalId] = useState<string | undefined>();
	// const [portals, setPortals] = useState<PortalProperties[]>([]);

	const rumah123PortalProfile = useMemo(() => {
		if (listing) {
			const portalProfile = listing.rumah123_officePortalProfile || listing.rumah123_agentPortalProfile;

			const listingPortalDetail = listing?.portalListing?.find(
				(item) => item.portalAgent?.portalId === portalProfile?.portalId
			);

			const portalListingInfo = listingPortals?.find(
				(v) => v.portalListingId === listingPortalDetail?.portalListingId
			);
			let email = portalProfile?.portalUsername;
			if (!isAdminOfficePlus && !!listing.rumah123_officePortalProfile) {
				email = maskEmail(portalProfile?.portalUsername || "");
			}

			return {
				portalProfile,
				portalListingInfo,
				listingPortalDetail,
				email,
			};
		}

		return undefined;
	}, [listing]);

	const lamudiPortalProfile = useMemo(() => {
		if (listing) {
			const portalProfile = listing.lamudi_officePortalProfile || listing.lamudi_agentPortalProfile;

			const listingPortalDetail = listing?.portalListing?.find(
				(item) => item.portalAgent?.portalId === portalProfile?.portalId
			);

			const portalListingInfo = listingPortals?.find(
				(v) => v.portalListingId === listingPortalDetail?.portalListingId
			);

			console.log("Lamudi Portal Profile Debug:", {
				portalProfile,
				listingPortalDetail,
				portalListingInfo,
				listingPortals,
				allPortalListings: listingPortals?.map((p) => ({
					portalListingId: p.portalListingId,
					status: p.status,
					message: p.message,
				})),
			});

			let email = portalProfile?.portalUsername;

			if (!isAdminOfficePlus && !!listing.lamudi_officePortalProfile) {
				email = maskEmail(portalProfile?.portalUsername || "");
			}
			return {
				portalProfile,
				portalListingInfo,
				listingPortalDetail,
				email,
			};
		}

		return undefined;
	}, [listing, listingPortals]);

	// useEffect(() => {
	// 	if (listing) {
	// 		(async () => {
	// 			setIsCheckingR123Email(true);
	// 			try {
	// 				const resCheck = await httpRequest.get<BaseResponseProps<{ isFound: boolean }>>(
	// 					`/listings/${listing.listingId}/check-email-r123`
	// 				);
	// 				setEmailConnectedToR123(resCheck.data.payload.isFound);
	// 			} catch (error) {
	// 				showErrorMessage(error, true);
	// 			} finally {
	// 				setIsCheckingR123Email(false);
	// 			}
	// 		})();
	// 	}
	// }, [listing]);

	// useEffect(() => {
	// 	(async () => {
	// 		try {
	// 			let { data: dataPortals } = await httpRequest.get<BaseResponsePaginationProps<PortalProperties>>(
	// 				"portals",
	// 				{
	// 					params: {
	// 						filterIsActive: true,
	// 					},
	// 				}
	// 			);
	// 			setPortals(dataPortals.payload.results);
	// 		} catch (error) {
	// 			showErrorMessage(error, true);
	// 		}
	// 	})();
	// }, []);

	// const renderEmailListing: EmailListing[] = useMemo(() => {
	// 	let results = [];
	// 	if (listing?.portalListing && listing.portalListing.length > 0) {
	// 		for (const portList of listing.portalListing) {
	// 			let temp: any = portList;
	// 			if (listing?.emailPortals && listing.emailPortals.length > 0) {
	// 				for (const emailPortal of listing.emailPortals) {
	// 					if (emailPortal.portalId === portList.portalAgent?.portalId) {
	// 						temp = {
	// 							...temp,
	// 							emailPortalListing: emailPortal,
	// 						};
	// 					}
	// 				}
	// 			}

	// 			results.push(temp);
	// 		}
	// 	}
	// 	return results;
	// }, [listing?.portalListing, listing?.emailPortals]);

	const hasntWatermark = listing?.photos?.some((photo: any) => !photo.hasOwnProperty("isWatermark"));

	const [isRetryLoading, setIsRetryLoading] = useState(false);
	const retryUploadToR123 = async (portListId: string) => {
		setIsRetryLoading(true);
		try {
			await httpRequest.post(`/portal-listings/retry-upload/${portListId}`);
			message.success("Retry upload initiated successfully");
			setIsFetch(true);
		} catch (error) {
			message.error(getErrorMessage(error));
		} finally {
			setIsRetryLoading(false);
		}
	};

	const STATUS_PORTAL_COLOR = (status: string) => {
		switch (status) {
			case EPortalListingResultStatus.completed:
			case EPortalListingResultStatus.Completed:
				return "#49AA19";
			case EPortalListingResultStatus.rejected:
			case EPortalListingResultStatus.failed:
				return "#DB4446";
			default:
				return "rgba(0, 0, 0, 0.85)";
		}
	};

	const ICON_STATUS = (status: string) => {
		switch (status) {
			case EPortalListingResultStatus.completed:
			case EPortalListingResultStatus.Completed:
				return (
					<CheckCircleOutlined
						style={{
							color: STATUS_PORTAL_COLOR(lamudiPortalProfile?.portalListingInfo?.status!),
						}}
					/>
				);
			case EPortalListingResultStatus.rejected:
			case EPortalListingResultStatus.failed:
				return (
					<CloseCircleOutlined
						style={{
							color: STATUS_PORTAL_COLOR(lamudiPortalProfile?.portalListingInfo?.status!),
						}}
					/>
				);
			default:
				return <InfoCircleOutlined />;
		}
	};

	return (
		<React.Fragment>
			{!isClosing && !isMinimal && (
				<Row
					gutter={[24, 0]}
					className="detail-bordered"
				>
					<Col
						span={24}
						className="no-border"
					>
						<Title level={4}>Agent Information</Title>
					</Col>
					<Col
						xs={{ span: 24 }}
						md={{ span: 12 }}
					>
						<DetailItem
							label="Agent Name"
							value={listing?.user?.nickName?.toUpperCase()}
						/>
					</Col>
					<Col
						xs={{ span: 24 }}
						md={{ span: 12 }}
					>
						<DetailItem
							label="Contact Agent"
							value={listing?.profile?.firstPhoneNumber}
						/>
					</Col>

					<Col
						xs={{ span: 24 }}
						md={{ span: 12 }}
					>
						<DetailItem
							label="Email Agent"
							value={
								listing?.profile?.mainEmail === EProfileMainEmail.REMAX
									? listing.profile.remaxEmail
									: listing?.profile?.privateEmail
							}
						/>
					</Col>
					<Col
						xs={{ span: 24 }}
						md={{ span: 12 }}
					>
						<DetailItem
							label="Office"
							value={listing?.office?.officeName}
						/>
					</Col>
				</Row>
			)}

			{!isHideListingCode && (
				<Row
					justify="space-between"
					style={{ alignItems: "center", paddingTop: 20 }}
				>
					<Col>
						<Title level={4}>Listing Information</Title>
					</Col>
					<Col>
						{listing?.listingRenewHistory && listing.listingRenewHistory.length > 0 ? (
							<Tag color="processing">Renew Listing</Tag>
						) : (
							<></>
						)}
						{listing?.listingTransferHistory && listing.listingTransferHistory.length > 0 ? (
							<Tag color="orange">Receive Listing</Tag>
						) : (
							<></>
						)}
					</Col>
				</Row>
			)}

			<Row
				gutter={[24, 0]}
				className="detail-bordered"
			>
				<Col
					span={24}
					className="no-border"
				>
					{hasntWatermark && !isClosing && listing?.status !== EListingStatus.CLOSED && (
						<Alert
							className="warning-watermark"
							message={
								<>
									Our system detects there are photos that still do not use watermark, please upload
									again to add watermark.
									<Link
										style={{
											paddingLeft: 6,
											color: "#e39909",
											fontWeight: "600",
											textDecoration: "underline",
										}}
										to={`/listing/${listing?.listingId}/edit/listing-information`}
									>
										Edit
									</Link>
								</>
							}
							type="warning"
							showIcon
							icon={<ExclamationCircleOutlined />}
						/>
					)}
				</Col>
				{!isHideListingCode && (
					<Col
						span={24}
						className="no-border"
					>
						<DetailItem
							label="Listing ID"
							value={listing?.listingCode}
							renderValue={(v) => (
								<Link
									style={{
										fontSize: 16,
										fontWeight: "bold",
									}}
									to={`/listing/${listing?.listingId}`}
								>
									{v}
								</Link>
							)}
						/>
					</Col>
				)}

				<Col
					span={24}
					className="no-border"
				>
					<ListingImagePreview photos={listing?.photos} />
				</Col>

				<Col span={24}>
					<DetailItem
						label="URL Video Listing (YouTube)"
						value={listing?.videoUrl?.[0]}
						renderValue={(url) => (
							<a
								href={url.toString()}
								target="_blank"
								rel="noreferrer"
							>
								{url}
							</a>
						)}
					/>
				</Col>
				<Col span={24}>
					<DetailItem
						label="Title"
						value={listing?.title}
					/>
				</Col>

				<Col span={24}>
					<DetailItem label="Description">
						<div
							dangerouslySetInnerHTML={{
								__html: listing?.description ?? "",
							}}
							className="listing-description"
						/>
					</DetailItem>
				</Col>

				<Col
					xs={{ span: 24 }}
					md={{ span: 12 }}
				>
					<DetailItem
						label="Country"
						value={listing?.country}
					/>
				</Col>
				<Col
					xs={{ span: 24 }}
					md={{ span: 12 }}
				>
					<DetailItem
						label="Province"
						value={listing?.province}
					/>
				</Col>

				<Col
					xs={{ span: 24 }}
					md={{ span: 12 }}
				>
					<DetailItem
						label="City/Region"
						value={listing?.city}
					/>
				</Col>
				<Col
					xs={{ span: 12 }}
					md={{ span: 6 }}
				>
					<DetailItem
						label="District"
						value={listing?.district}
					/>
				</Col>
				<Col
					xs={{ span: 12 }}
					md={{ span: 6 }}
				>
					<DetailItem
						label="Postal Code"
						value={listing?.postalCode}
					/>
				</Col>

				<Col
					xs={{ span: 24 }}
					md={{ span: 12 }}
				>
					<DetailItem
						label="Street Name"
						value={listing?.streetName}
					/>
				</Col>
				<Col
					xs={{ span: 12 }}
					md={{ span: 6 }}
				>
					<DetailItem
						label="Block Number"
						value={listing?.blokName}
					/>
				</Col>
				<Col
					xs={{ span: 12 }}
					md={{ span: 6 }}
				>
					<DetailItem
						label="Unit Number"
						value={listing?.houseNumber}
					/>
				</Col>

				<Col span={24}>
					<MapsPickerComponent
						customCenter={
							listing?.latitude && listing.longitude
								? {
										lat: listing.latitude,
										lng: listing.longitude,
								  }
								: undefined
						}
						value={
							listing?.latitude && listing.longitude
								? {
										latitude: listing.latitude,
										longitude: listing.longitude,
								  }
								: undefined
						}
					/>
				</Col>
				<Col
					style={{ height: 20 }}
					span={24}
					className="no-border"
				></Col>
				<Col
					span={24}
					className="no-border"
				>
					<Title level={4}>Specification Listing</Title>
				</Col>

				<Col
					xs={{ span: 24 }}
					md={{ span: 12 }}
				>
					<DetailItem label="Sale/Rent">
						<SellOrRentComponent value={listing?.sellOrRent} />
					</DetailItem>
				</Col>
				<Col
					xs={{ span: 12 }}
					md={{ span: 6 }}
				>
					<DetailItem
						label="Listing Type"
						value={listing?.listingType ? formatUcWords(listing.listingType) : ""}
					/>
				</Col>
				<Col
					xs={{ span: 12 }}
					md={{ span: 6 }}
				>
					<DetailItem
						label="Property Category"
						value={listing?.listingPart?.name}
					/>
				</Col>

				{listing?.sellOrRent === EListingSellOrRent.RENT && (
					<React.Fragment>
						<Col
							xs={{ span: 24 }}
							md={{ span: 12 }}
							lg={{ span: 8 }}
						>
							<DetailItem
								label="Daily Rent"
								value={listing?.additionalPriceFreq?.daily}
								renderValue={priceFormat}
							/>
						</Col>
						<Col
							xs={{ span: 24 }}
							md={{ span: 12 }}
							lg={{ span: 8 }}
						>
							<DetailItem
								label="Monthly Rent"
								value={listing?.additionalPriceFreq?.monthly}
								renderValue={priceFormat}
							/>
						</Col>
						<Col
							xs={{ span: 24 }}
							md={{ span: 24 }}
							lg={{ span: 8 }}
						>
							<DetailItem
								label="Yearly Rent"
								value={listing?.additionalPriceFreq?.yearly}
								renderValue={priceFormat}
							/>
						</Col>
						<Col
							xs={{ span: 24 }}
							md={{ span: 24 }}
							lg={{ span: 24 }}
						>
							<div style={{ margin: "10px 0px" }}>
								<Space
									style={{
										width: "100%",
									}}
								>
									<Typography.Text className="detail-item-title">
										Thumbnail/Portal Price{" "}
									</Typography.Text>
									<Typography.Text
										style={{
											color: "#faad14",
											fontWeight: "bold",
											fontSize: 16,
										}}
									>
										:
									</Typography.Text>
									<Typography.Text
										style={{
											color: "#faad14",
											fontWeight: "bold",
											fontSize: 16,
										}}
									>
										{getListingPriceNominal(listing, true)}
									</Typography.Text>
								</Space>
							</div>
						</Col>
					</React.Fragment>
				)}

				<Col
					xs={{ span: 24 }}
					md={{ span: 12 }}
				>
					<DetailItem
						label="Property Type"
						value={listing?.listingPropertyType?.name}
					/>
				</Col>
				<Col
					xs={{ span: 24 }}
					md={{ span: 12 }}
				>
					<DetailItem
						label="Certificate Type"
						value={listing?.listingCertificateType?.name}
					/>
				</Col>

				<Col
					xs={{ span: 24 }}
					md={{ span: 12 }}
				>
					<DetailItem
						label="Building Size"
						value={listing?.buildingArea}
						renderValue={(v) => (
							<>
								{v}m<sup>2</sup>
							</>
						)}
					/>
				</Col>
				<Col
					xs={{ span: 24 }}
					md={{ span: 12 }}
				>
					<DetailItem
						label="Land Size"
						value={listing?.landArea}
						renderValue={(v) => (
							<>
								{v}m<sup>2</sup>
							</>
						)}
					/>
				</Col>

				<Col
					xs={{ span: 24 }}
					md={{ span: 12 }}
				>
					<DetailItem
						label="Building Is Facing"
						value={listing?.buildingFace ? formatUcWords(listing.buildingFace) : ""}
					/>
				</Col>
				<Col
					xs={{ span: 24 }}
					md={{ span: 12 }}
				>
					<DetailItem
						label="Number Of Floors"
						value={listing?.numberOfFloor}
					/>
				</Col>

				<Col
					xs={{ span: 24 }}
					md={{ span: 12 }}
				>
					<DetailItem
						label="Bedroom"
						value={listing?.mainBedroom}
					/>
				</Col>
				<Col
					xs={{ span: 24 }}
					md={{ span: 12 }}
				>
					<DetailItem
						label="Bathroom"
						value={listing?.mainBathroom}
					/>
				</Col>

				<Col
					xs={{ span: 24 }}
					md={{ span: 12 }}
				>
					<DetailItem
						label="Housekeeper Bedroom"
						value={listing?.housekeepBedroom}
					/>
				</Col>
				<Col
					xs={{ span: 24 }}
					md={{ span: 12 }}
				>
					<DetailItem
						label="Housekeeper Bathroom"
						value={listing?.housekeepBathroom}
					/>
				</Col>

				<Col span={24}>
					<DetailItem label="Facility">
						{listing?.facilities
							?.filter((item) => item.total > 0)
							.map((item) => {
								return item.facilityName + " (" + item.total + ")";
							})
							.join(", ")}
					</DetailItem>
				</Col>

				{listing?.sellOrRent === EListingSellOrRent.SELL && (
					<Col span={24}>
						<DetailItem
							label="Price"
							value={priceFormat(listing?.price)}
						/>
					</Col>
				)}

				<Col
					xs={{ span: 24 }}
					md={{ span: 12 }}
				>
					<DetailItem
						label="Renew Listing"
						value={
							listing?.listingRenewHistory?.[0]?.createdAt
								? formatDate(listing.listingRenewHistory[0].createdAt)
								: ""
						}
					/>
				</Col>
				<Col
					xs={{ span: 24 }}
					md={{ span: 12 }}
				>
					<DetailItem
						label="Transfer From"
						value={listing?.listingTransferHistory?.[0]?.fromMetadata?.userName}
					/>
				</Col>
				{/* <Col span={24}>
					<Title
						level={4}
						style={{
							marginBottom: 8,
						}}
					>
						Connected Portal
					</Title>
					<DetailItem label="">
						{portals.some((portal) =>
							renderEmailListing.some(
								(value) => value.portalAgent?.portal?.portalName === portal.portalName
							)
						) ? (
							<Row gutter={[24, 24]}>
								{portals.map((portal, idx) => {
									const emailListingItem = renderEmailListing.find(
										(value) => value.portalAgent?.portal?.portalName === portal.portalName
									);
									const emailValue = emailListingItem?.emailPortalListing?.email || "";
									const isConnected = !!emailListingItem;

									if (!isConnected) return null;

									const listingPortalDetail = listing?.portalListing?.find(
										(item) => item.portalAgent?.portal?.portalName === portal.portalName
									);

									const portalListingInfo = listingPortals?.find(
										(v) => v.portalListingId === listingPortalDetail?.portalListingId
									);

									return (
										<Col
											key={idx}
											xs={{ span: 24 }}
											md={{ span: 12 }}
										>
											<Space
												direction="vertical"
												size={8}
												style={{ width: "100%" }}
											>
												<div style={{ display: "flex-col", alignItems: "center", gap: 16 }}>
													<AgentPortal
														userId={listing?.userId || ""}
														emailListing={renderEmailListing}
														portalName={portal.portalName}
													/>

													{isConnected && (
														<div style={{ flex: 1 }}>
															<Typography.Text
																style={{ fontSize: 14, fontWeight: "bold" }}
															>
																Login ID: {emailValue || "-"}
															</Typography.Text>
														</div>
													)}
												</div>

												{portal.portalName.toLowerCase().includes("rumah123") &&
													isConnected && (
														<Spin spinning={isCheckingR123Email}>
															<Space size={4}>
																{emailConnectedToR123 ? (
																	<CheckCircleOutlined
																		style={{
																			color: "#49AA19",
																		}}
																	/>
																) : (
																	<CloseCircleOutlined
																		style={{
																			color: "#DB4446",
																		}}
																	/>
																)}
																<Typography.Text
																	style={{
																		fontSize: 12,
																		color: emailConnectedToR123
																			? "#49AA19"
																			: "#DB4446",
																	}}
																>
																	{emailConnectedToR123
																		? "This email is registered in rumah123.com"
																		: "This email is not registered in rumah123.com"}
																</Typography.Text>
															</Space>
														</Spin>
													)}

												{portal.portalName.toLowerCase().includes("rumah123") && (
													<Space
														size={8}
														style={{ gap: 10 }}
													>
														{portalListingInfo &&
															(portalListingInfo.status === "failed" ||
																portalListingInfo?.status === "Rejected") && (
																<Button
																	onClick={() =>
																		retryUploadToR123(
																			listingPortalDetail?.portalListingId || ""
																		)
																	}
																	loading={isRetryLoading}
																	type="link"
																	size="small"
																	style={{ padding: 0 }}
																>
																	Retry upload to Rumah123
																</Button>
															)}
														<Button
															type="link"
															size="small"
															onClick={() => {
																setShowLog(true);
															}}
															style={{
																width: "150px",
																paddingLeft: 6,
																backgroundColor: "lightgray",
																borderColor: "black",
																color: "black",
																fontWeight: "400",
															}}
														>
															See Portal Logs
														</Button>

														<Button
															type="link"
															size="small"
															onClick={() => {
																if (portalListingInfo?.link) {
																	window.open(portalListingInfo.link, "_blank");
																} else {
																	const statusMessage = portalListingInfo?.message
																		? getErrorMessage(portalListingInfo.message)
																		: portalListingInfo?.status;
																	message.info(statusMessage);
																}
															}}
															style={{
																width: "150px",
																paddingLeft: 6,
																backgroundColor: "lightgray",
																borderColor: "black",
																color: "black",
																fontWeight: "400",
															}}
														>
															Open Link
														</Button>
													</Space>
												)}
											</Space>
										</Col>
									);
								})}
							</Row>
						) : (
							<Typography.Text type="secondary">
								This listing is not connected to any portal
							</Typography.Text>
						)}
					</DetailItem>
				</Col> */}

				{(rumah123PortalProfile?.portalProfile || lamudiPortalProfile) && !isHideListingPortal ? (
					<Col
						span={24}
						className="detail-bordered"
					>
						<Title
							level={4}
							style={{
								marginBottom: 8,
							}}
						>
							Portal Connection
						</Title>
						<Row
							gutter={[24, 0]}
							style={{
								marginBottom: 10,
							}}
						>
							{rumah123PortalProfile?.portalProfile ? (
								<>
									<Col
										xs={{ span: 24 }}
										md={{ span: 12 }}
									>
										<Space direction="vertical">
											<Space>
												<Checkbox
													checked
													className="checkbox-cursor-auto"
												/>
												<Typography.Text>
													{rumah123PortalProfile.portalProfile?.portal?.portalName}
												</Typography.Text>
											</Space>
											<Typography.Text strong>
												Login ID: {rumah123PortalProfile?.email}
											</Typography.Text>
											<Space size={4}>
												{ICON_STATUS(rumah123PortalProfile?.portalListingInfo?.status!)}

												<Typography.Text
													style={{
														fontSize: 12,
														color: STATUS_PORTAL_COLOR(
															rumah123PortalProfile?.portalListingInfo?.status!
														),
													}}
												>
													{rumah123PortalProfile?.portalListingInfo?.message}
												</Typography.Text>
											</Space>
											<Space
												size={8}
												style={{ gap: 10 }}
												wrap
											>
												{rumah123PortalProfile?.portalListingInfo &&
													(rumah123PortalProfile?.portalListingInfo.status === "failed" ||
														rumah123PortalProfile?.portalListingInfo?.status ===
															"Rejected") && (
														<Button
															onClick={() =>
																retryUploadToR123(
																	rumah123PortalProfile?.listingPortalDetail
																		?.portalListingId || ""
																)
															}
															loading={isRetryLoading}
															type="link"
															size="small"
															style={{ padding: 0 }}
														>
															Retry upload to Rumah123
														</Button>
													)}
												{isAdminOfficePlus && (
													<Button
														type="link"
														size="small"
														onClick={() => {
															setShowLog(true);
														}}
														style={{
															width: "150px",
															paddingLeft: 6,
															backgroundColor: "lightgray",
															borderColor: "black",
															color: "black",
															fontWeight: "400",
														}}
													>
														See Portal Logs
													</Button>
												)}

												<Button
													type="link"
													size="small"
													onClick={() => {
														if (rumah123PortalProfile?.portalListingInfo?.link) {
															window.open(
																rumah123PortalProfile?.portalListingInfo.link,
																"_blank"
															);
														} else {
															const statusMessage = rumah123PortalProfile
																?.portalListingInfo?.message
																? getErrorMessage(
																		rumah123PortalProfile?.portalListingInfo.message
																  )
																: rumah123PortalProfile?.portalListingInfo?.status;
															message.info(statusMessage);
														}
													}}
													style={{
														width: "150px",
														paddingLeft: 6,
														backgroundColor: "lightgray",
														borderColor: "black",
														color: "black",
														fontWeight: "400",
													}}
												>
													Open Link
												</Button>
											</Space>
										</Space>
									</Col>
								</>
							) : (
								<></>
							)}

							{lamudiPortalProfile?.portalProfile ? (
								<>
									<Col
										xs={{ span: 24 }}
										md={{ span: 12 }}
									>
										<Space direction="vertical">
											<Space>
												<Checkbox
													checked
													className="checkbox-cursor-auto"
												/>
												<Typography.Text>
													{lamudiPortalProfile.portalProfile?.portal?.portalName}
												</Typography.Text>
											</Space>
											<Typography.Text strong>
												Login ID: {lamudiPortalProfile.email}
											</Typography.Text>
											<Space size={4}>
												{ICON_STATUS(lamudiPortalProfile?.portalListingInfo?.status!)}

												<Typography.Text
													style={{
														fontSize: 12,
														color: STATUS_PORTAL_COLOR(
															lamudiPortalProfile?.portalListingInfo?.status!
														),
													}}
												>
													{lamudiPortalProfile?.portalListingInfo?.message}
												</Typography.Text>
											</Space>
											<Space
												size={8}
												style={{ gap: 10 }}
												wrap
											>
												{lamudiPortalProfile?.portalListingInfo &&
													(lamudiPortalProfile?.portalListingInfo.status ===
														EPortalListingResultStatus.failed ||
														lamudiPortalProfile?.portalListingInfo?.status ===
															EPortalListingResultStatus.rejected) && (
														<Button
															onClick={() =>
																retryUploadToR123(
																	lamudiPortalProfile?.listingPortalDetail
																		?.portalListingId || ""
																)
															}
															loading={isRetryLoading}
															type="link"
															size="small"
															style={{ padding: 0 }}
														>
															Retry upload to Lamudi
														</Button>
													)}
												{isAdminOfficePlus && (
													<Button
														type="link"
														size="small"
														onClick={() => {
															setSelectedPortalId(
																lamudiPortalProfile?.portalProfile?.portalId
															);
															setShowLog(true);
														}}
														style={{
															width: "150px",
															paddingLeft: 6,
															backgroundColor: "lightgray",
															borderColor: "black",
															color: "black",
															fontWeight: "400",
														}}
													>
														See Portal Logs
													</Button>
												)}
											</Space>
										</Space>
									</Col>
								</>
							) : (
								<></>
							)}
						</Row>
					</Col>
				) : (
					<></>
				)}

				<Col span={24}>
					<Title
						level={4}
						style={{
							marginBottom: 8,
						}}
					>
						PDF Settings
					</Title>
					<DetailItem
						label="PDF Orientation"
						value={listing?.pdfOrientation}
						renderValue={(v) => formatUcWords(v as string)}
					/>
				</Col>
			</Row>

			{isClosing && !isMinimal && (
				<Row
					gutter={[24, 0]}
					className="detail-bordered"
				>
					<Col
						span={24}
						className="no-border"
					>
						<Title level={4}>Agent Information</Title>
					</Col>
					<Col
						xs={{ span: 24 }}
						md={{ span: 12 }}
					>
						<DetailItem
							label="Agent Name"
							value={listing?.user?.nickName?.toUpperCase()}
						/>
					</Col>
					<Col
						xs={{ span: 24 }}
						md={{ span: 12 }}
					>
						<DetailItem
							label="Contact Agent"
							value={listing?.profile?.firstPhoneNumber}
						/>
					</Col>

					<Col
						xs={{ span: 24 }}
						md={{ span: 12 }}
					>
						<DetailItem
							label="Email Agent"
							value={
								listing?.profile?.mainEmail === EProfileMainEmail.REMAX
									? listing.profile.remaxEmail
									: listing?.profile?.privateEmail
							}
						/>
					</Col>
					<Col
						xs={{ span: 24 }}
						md={{ span: 12 }}
					>
						<DetailItem
							label="Office"
							value={listing?.office?.officeName}
						/>
					</Col>
				</Row>
			)}

			{/* {!isClosing && (
				<Row
					gutter={[24, 0]}
					className="detail-bordered"
				>
					<Col
						span={24}
						className="no-border"
					>
						<Title
							level={4}
							style={{
								marginBottom: 8,
							}}
						>
							Portal Information
						</Title>
					</Col>
					{listing?.portalListing && listing.portalListing.length > 0 ? (
						listing.portalListing.map((item, idx) => {
							const listingPortalDetail = listingPortals?.find(
								(v) => v.portalListingId === item.portalListingId
							);

							return (
								<Col
									key={idx}
									xs={{ span: 24 }}
									md={{ span: 12 }}
								>
									{item.portalAgent?.portal?.portalName && listingPortalDetail ? (
										<DetailItem label={item.portalAgent?.portal?.portalName}>
											<Space direction="vertical">
												{item.portalAgent?.portal?.portalName === "Rumah123" &&
													listingPortalDetail.link ? (
													<LinkAntd
														ellipsis
														href={listingPortalDetail.link}
														target="_blank"
														rel="noreferrer"
													>
														{listingPortalDetail.link}
													</LinkAntd>
												) : undefined}
												{!listingPortalDetail?.link && (
													<Typography.Text
														style={{
															color:
																listingPortalDetail.status === "failed" ||
																	listingPortalDetail?.status === "Rejected"
																	? "red"
																	: "rgba(0, 0, 0, 0.85)",
														}}
													>
														{listingPortalDetail.message
															? getErrorMessage(listingPortalDetail.message)
															: listingPortalDetail.status}
													</Typography.Text>
												)}
												{item.portalAgent?.portal?.portalName === "Rumah123" && (
													<>
														<Space size={4}>
															{listingPortalDetail.status === "failed" ||
																listingPortalDetail?.status === "Rejected" ? (
																<Button
																	onClick={() =>
																		retryUploadToR123(item.portalListingId)
																	}
																	loading={isRetryLoading}
																	type="primary"
																>
																	Retry upload to Rumah123
																</Button>
															) : (
																<></>
															)}
															<Button
																onClick={() => {
																	setShowLog(true);
																}}
															>
																<EyeOutlined /> See Portal Logs
															</Button>
														</Space>
													</>
												)}
											</Space>
										</DetailItem>
									) : (
										<NotSet />
									)}
								</Col>
							);
						})
					) : (
						<Col span={24}>
							<NotSet />
						</Col>
					)}
				</Row>
			)} */}

			<PortalSyncLogModal
				title={
					selectedPortalId === LAMUDI_ID
						? `Lamudi Portal Listing Sync Log For Listing ${listing?.listingCode}`
						: `Rumah123 Portal Listing Sync Log For Listing ${listing?.listingCode}`
				}
				portalId={selectedPortalId}
				open={showLog}
				onClose={() => {
					setShowLog(false);
					setSelectedPortalId(undefined);
				}}
				listingId={listingId}
			/>

			{!isMinimal && !hideNavigation && (
				<Row gutter={[24, 0]}>
					<Col
						span={24}
						style={{ height: 20 }}
					></Col>

					<Col span={12}>
						<Button
							type="primary"
							onClick={() => history.replace("/listing/" + listingId + "/seller-information")}
							className="btn-fixed-lg"
						>
							Previous
						</Button>
					</Col>
					<Col
						span={12}
						style={{ textAlign: "right" }}
					>
						<Button
							// disabled={!hasListingPortal}
							disabled
							type="primary"
							// onClick={() => {
							// 	if (hasListingPortal) {
							// 		history.replace("/listing/" + listingId + "/portal-information");
							// 	}
							// }}

							className="btn-fixed-lg"
						>
							Next
						</Button>
					</Col>
				</Row>
			)}
		</React.Fragment>
	);
};
export default DetailListingInformation;
